import React from "react";
import * as actions from './actions';
export default function FilterCategory({ FilterData, filterCount, eleRef ,isApp}) {
    const items = [];

    const sublistul = [];
    var fooArray = Object.entries(FilterData);
    fooArray.forEach(([key, value]) => {
        var sublist = [];
        var j=Object.keys(FilterData).indexOf(key)
        items.push(
            <li key={key} className={`cls_${key.split(/\s+/).slice(0,1)[0].toLowerCase()+j} active`} onClick={() => actions.showSubCat(`${(key.split(/\s+/).slice(0,1)[0].toLowerCase())+j}`)}>
                <span className="catname R14_42">{key && key.charAt(0).toUpperCase() + key.slice(1)}</span>
                <div className="subcatCount"></div>
            </li>);

        for (var i = 0; i < value.length; i++) {
            sublist.push(<li key={`b_${i}`} onClick={(e) => actions.checkfiltersubcat(e)} >
                <span className="icon check left" data-icon-font="z"></span>
                <span className="subcatname R14_42">{value[i]}</span>
            </li>);
        }
        sublistul.push(<ul key={`a_${key}`} className={`sub${key.split(/\s+/).slice(0,1)[0].toLowerCase()+j} subcategorieslist active`}>
            {sublist}
        </ul>);
    });

    return (
        <div className="filter-overlay overlay">
            <div className="filter-popup filter_popups">
                <div className="filter_by">
                    <span className="M18_42">Filter By</span>
                    <span className="right icon" id="dev_close_popup" data-icon-font="C" onClick={(e) => eleRef.onclosePopup()}></span>
                </div>
                <div className="catg_filter">
                    <ul className="left">
                        <li className="category_list">
                            <ul className="left categorieslist">
                                {items}
                            </ul>
                        </li>
                        <li className="subcategory_list">
                            {/* <div className="filter_search left">
                                <span className="icon searchflticon" data-icon-font="'"></span>
                                <input className="R14_42" type="text" id="sabcat_search" onKeyUp={() => actions.mysearchlist()} placeholder="Search" autoFocus />
                            </div> */}
                            {sublistul}
                        </li>
                    </ul>
                </div>
                <div className="cancel_apply_btn">
                    <div className="submit_btns">
                        <div className="cancelfilter M14_9e" onClick={(e) => actions.clearAll(e, eleRef,isApp)}>
                            Clear All
                        </div>
                        <div className="applyfilter M14_pink dev_listfilter" onClick={(e) => actions.applyfilter(e,filterCount, eleRef,isApp)}>
                            <span className="appfiltbtn">APPLY</span>
                        </div>
                    </div>
                    <input type="hidden" id="cubcatstrr" value=" " />
                </div>
            </div>
        </div>
    )
}
